/**
 * BatchGeoMapScaleBarDefaultUnit is an arg less component that simply will set
 * the default value of the Google Maps Scale Bar. Normally, Google Maps always
 * uses KM and M but for US residents it makes more sense to use MI and FT. Also
 * people don't realize you can click on it to change it.
 *
 * To override Google Maps' behavior we do some DOM sniffing and such to set the
 * default manually.
 *
 * @example
 * BatchGeoMapScaleBarDefaultUnit(); // that's it!
 */
(function () {
  window.BatchGeoMapScaleBarDefaultUnit = function () {
    /* Some Samsung Smart TVs have issues loading jQuery. The dom checking loop
     * within this module unfortunately in some cases can lead to an infinite
     * loop of errors that uses up our Sentry quota. Not the most elegant of
     * solutions but will at least treat this symptom.
     *
     * See https://sentry.io/organizations/batchgeo/issues/1880570206/ for context.
     */
    if (BatchGeoDevices.is("samsungsmarttv")) return;

    // This will return the user's locale such as `en-US`
    var language = navigator.language.toLowerCase();

    // In a loop since we don't know when the scale bar element will appear.
    var intervalInstance = setInterval(function () {
      var $potentialScaleBarElements = $(".gm-style-cc");

      // We keep checking until all possible .gm-style-cc elements are
      // there. It should be at least 4. Allowed for more than 4 in case
      // anything is added by Google later.
      if ($potentialScaleBarElements.length >= 4) {
        // Stop the interval now that is all loaded
        clearInterval(intervalInstance);

        // Loop through each potential element to find the real one
        $potentialScaleBarElements.each(function () {
          // The real one should match this regex which is looking for
          // a number, space, then either km, m, mi, or ft.
          if (/\d+ km|m|mi|ft$/.test($(this).text().trim())) {
            // If it matches then we need to figure out which scale
            // unit to match against. If it is en-us we match for km
            // and m so that we can toggle to mi and ft. And if it's
            // not en-us we do the opposite.
            var scaleBarToggleRegex =
              language === "en-us" ? /\d+ km|m$/ : /\d+ ft|mi$/;

            // Get the scale bar's text ("50 m " for example). We
            // need to trim it because Google adds a space at the
            // end. We also don't add spaces to the regex because we
            // can't be sure itll always only be 1 space.
            var scaleBarText = $(this).text().trim();

            // If the regex matches with the text given then we know
            // we need to toggle it. Since Google doesn't provide a
            // way to toggle this in an API form we need to do this
            // the janky way: click it.
            if (scaleBarToggleRegex.test(scaleBarText)) {
              $(this).click();
            }
          }
        });
      }
    }, 100);
  };
})();
